import { Skeleton, Text } from '@chakra-ui/react';
import { useResource, useResources } from 'datx-jsonapi-react';
import NextLink from 'next/link';

import { useAnalytics } from '@/context/Analytics';
import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { getOriginalSeries } from '@/queries/originals-series';
import { queryOriginalsLectures } from '@/queries/thin-lectures';

export const ViewAllButton = () => {
  const analytics = useAnalytics();

  const { id: seriesId } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { data: series } = useResource(getOriginalSeries(seriesId));
  const { error, meta } = useResources(queryOriginalsLectures(series?.subject?.id));

  if (error) throw error;

  return (
    <Skeleton isLoaded={Boolean(meta)}>
      <NextLink href={`/library?subject_subtree_of_id=${series?.subject?.id}`} passHref legacyBehavior>
        <Text
          as="a"
          whiteSpace="nowrap"
          align="right"
          cursor="pointer"
          fontWeight="normal"
          _hover={{ textDecoration: 'underline' }}
          onClick={() =>
            analytics.track('originals_view_all_related_click', {
              subject_name: series?.subject?.id,
              subject_id: series?.subject?.name,
              originals_id: seriesId,
            })
          }
        >
          view all
          <Text as="span" color="violet.500" fontWeight="bold">
            {` ${meta?.totalCount} `}
          </Text>
          lectures
        </Text>
      </NextLink>
    </Skeleton>
  );
};
